// All business content / config for New India Trading Corporation landing page.
export const BUSINESS = {
  name: "New India Trading Corporation",
  shortName: "New India",
  tagline: "Strength Behind Every Space",
  founder: "Mr. A.K. Abrar",
  yearsExperience: 25,
  type: "Wholesale & Retail",
  description:
    "Dealers in all kinds of plywood, block boards, formica sheets, flush doors and shuttering & packing plywood. Trusted by builders, packagers and interior designers across India for over 25 years.",
  phone: "+91 82176 87406",
  phoneRaw: "+918217687406",
  whatsappRaw: "918217687406",
  email: "nitcply@yahoo.com",
  address:
    "#48, Opposite Metro Station, Nagawara Main Road, 1st Cross, #66, Pillana Garden, Bangalore-560084",
  addressShort: "Nagawara Main Road, Bangalore-560084",
  hours: "9:00 AM – 8:00 PM",
  gst: "29AZEPA6221C1ZX",
  tradeLicense: "TradeLicense",
  mapsUrl:
    "https://www.google.com/maps/place/New+India+Trading+Corporation/@13.0098152,77.6119432,17z/data=!3m1!4b1!4m6!3m5!1s0x3bae16fdae2ac2cf:0x2dd96e5de4be2127!8m2!3d13.00981!4d77.6145181!16s%2Fg%2F11b74hy844",
  embedMap:
    "https://www.google.com/maps?q=New+India+Trading+Corporation+Nagawara+Bangalore&output=embed",
  logo: "/NITC_Logo.jpeg",
};

export const STATS = [
  { value: 25, suffix: "+", label: "Years of Trust" },
  { value: 5000, suffix: "+", label: "Clients Served" },
  { value: 50, suffix: "+", label: "Product Variants" },
  { value: 100, suffix: "%", label: "Pan India Delivery" },
];

export const PRODUCTS = [
  {
    group: "Plywood & Boards",
    items: [
      { name: "Plywood", desc: "Commercial & MR grade plywood for furniture and interiors." },
      { name: "Block Boards and OSB", desc: "Strong solid wood core boards for shelves and doors." },
      { name: "Marine Plywood", desc: "BWP grade, fully waterproof for kitchens and bathrooms." },
      { name: "Waterproof Plywood", desc: "BWR grade, moisture resistant for humid spaces." },
      { name: "Shuttering Plywood", desc: "Heavy-duty film faced sheets for construction." },
      { name: "Packing Plywood", desc: "Economical sheets for crating & export packaging." },
      { name: "MDF", desc: "Medium density fibreboard for smooth painted surfaces." },
      { name: "Particle Board", desc: "Cost-effective base for modular furniture." },
    ],
  },
  {
    group: "Laminates, Doors & Hardware",
    items: [
      { name: "Formica Sheets", desc: "Premium decorative laminates in 1000+ finishes." },
      { name: "Flush Doors", desc: "Solid core doors, smooth ready-to-finish surfaces." },
      { name: "Veneers", desc: "Natural wood veneers — walnut, teak, oak, rosewood." },
      { name: "PVC Sheets", desc: "Lightweight waterproof boards for bathrooms & exteriors." },
      { name: "Doors", desc: "Pre-finished and customizable door solutions." },
      { name: "Panels", desc: "Decorative wall and ceiling panels." },
      { name: "Edge Bands", desc: "PVC edge banding tapes in matching laminate colours." },
      { name: "Adhesives", desc: "Industry-grade fevicol, white glue & contact bonds." },
    ],
  },
];

export const BRANDS = {
  budget: ["Greenply", "CenturyPly", "Trojan"],
  premium: ["Merino", "Royale Touche"],
};

export const WHY_CHOOSE = [
  {
    title: "Premium Quality",
    desc: "Only authorised stock from India's top plywood and laminate manufacturers.",
    icon: "ShieldCheck",
  },
  {
    title: "Competitive Pricing",
    desc: "Direct dealership rates with transparent quotations — no hidden costs.",
    icon: "BadgeIndianRupee",
  },
  {
    title: "Bulk Supply",
    desc: "Container-load capacity for packaging companies, builders and exporters.",
    icon: "Truck",
  },
  {
    title: "Trusted Service",
    desc: "25+ years of relationships with builders, designers and B2B clients.",
    icon: "Handshake",
  },
  {
    title: "Timely Delivery",
    desc: "Reliable dispatch across India with dedicated logistics partners.",
    icon: "Clock",
  },
];

export const GALLERY = [
  { src: "/generated/storefront.png", label: "Our Showroom", span: "lg:col-span-2 lg:row-span-2" },
  { src: "/generated/warehouse.png", label: "Warehouse & Godown", span: "" },
  { src: "/generated/plywood_stack.png", label: "Plywood Stacks", span: "" },
  { src: "/generated/showroom_interior.png", label: "Laminate Showroom", span: "lg:col-span-2" },
  { src: "/generated/laminate_display.png", label: "Premium Laminates", span: "" },
  { src: "/generated/flush_doors.png", label: "Flush Doors", span: "" },
  { src: "/generated/veneer_swatches.png", label: "Natural Veneers", span: "lg:col-span-2" },
];

export const TESTIMONIALS = [
  {
    quote:
      "We have been sourcing packing plywood from New India Trading for over 15 years. Their consistency in quality and on-time bulk dispatch keeps our export packaging line running smoothly.",
    author: "Operations Lead",
    company: "Ficus Pax Pvt Ltd",
    tag: "Packaging Partner",
  },
  {
    quote:
      "Mr. Abrar's team understands a designer's deadlines. We get the laminate and veneer shades we need, exactly when we need them. They are now our default plywood partner.",
    author: "Principal Designer",
    company: "Sapphire City Interiors",
    tag: "Interior Designer",
  },
  {
    quote:
      "NITC has supplied us with reliable material at fair prices for years. Best of all, they are honest and transparent — no last-minute price hikes or quality compromises.",
    author: "Procurement Manager",
    company: "GWP Solutions",
    tag: "Packaging Partner",
  },
  {
    quote:
      "Honest pricing, premium brands, and a team that actually picks up the phone. That alone makes them stand out in this market.",
    author: "Independent Architect",
    company: "Bangalore",
    tag: "Retail Client",
  },
];

// SEO keywords
export const SEO_KEYWORDS = [
  "plywood dealer in Bangalore",
  "laminate shop in Bangalore",
  "wholesale plywood supplier",
  "formica sheets dealer",
  "marine plywood Bangalore",
  "shuttering plywood supplier",
];
